export class Help
{
	helpId: number;
	helpDate: Date;
}
